<template>
  <div id="sellerCommentsPage">
    <v-main class="overflow-hidden">
      <BackBar/>
      <div class="container-fluid px-1">
        <div class="row">
          <div class="col-12 col-md-6 mx-auto pt-0">
            <div class="row ">
              <div class="col-12">
                <div class="bg-white py-5 px-3 rounded-lg">
                  <i class="fa-solid fa-comments fa-2xl transform-icon-to-top"></i>
                  <span class="font16px mr-2 font-weight-bold">نظرات </span>
                </div>
              </div>
              <div class="col-4 text-center font-weight-bold">
                <span :class="productsCommentsTab ? 'profile-active-tab':''" class="pointer"
                      @click="showProductsCommentsTab">نظرات محصولات</span>
              </div>
              <div class="col-4 text-center font-weight-bold">
                <span :class="postsCommentsTab ? 'profile-active-tab':''" class="pointer" @click="showPostsCommentsTab">نظرات پست ها</span>
              </div>
              <div class="col-4 text-center font-weight-bold">
                <span :class="storesCommentsTab ? 'profile-active-tab':''" class="pointer"
                      @click="showStoresCommentsTab">نظرات فروشگاه</span>
              </div>

            </div>
          </div>
        </div>
        <div v-if="productsCommentsTab" class="row">
          <div v-if="productsComments.length <= 0" class="col-12  text-center">
            <div><i class="fa-light fa-face-frown-slight fa-3x grey--text"></i></div>
            <div class="mt-2">
              هنوز نظری ثبت نشده است
            </div>

          </div>
          <div v-else class="col-md-6 mx-auto pt-0">
            <div class="container">
              <div v-for="(item,i) in productsComments" :key="i" class="row ">
                <div class="col-12  mx-auto">
                  <div class="row">
                    <div class="col-4 p-1">
                      <v-img :height="$vuetify.breakpoint.xs ? 117 : 140" :src="$replaceHttps(item.ProductImageUrl)"
                             class="rounded-lg">
                      </v-img>
                    </div>
                    <div class="col-8 px-0 d-flex flex-column justify-space-between pl-2">
                      <div class="d-flex justify-space-between">
                        <div class="primary-text text-truncate">{{ item.Name }}</div>
                        <div><i class="fa-solid fa-star yellow--text ml-1"></i>{{ item.ProductRate }}</div>
                      </div>
                      <div class="d-flex"><span v-if="item.ProductDiscount !== 0"
                                                class="product-card-discount rounded-circle m-0">
        {{ item.ProductDiscount }} %</span>
                        <span v-if="item.ProductDiscount !== 0"
                              class="font12px pt-2 text-decoration-line-through grey--text mr-3"> {{
                            item.price
                          }}</span>
                      </div>
                      <div class="d-flex justify-space-between">
                        <div>{{ $computingPriceOffer(item.ProductPrice, item.ProductDiscount) }} تومان</div>
                        <router-link :to="{name:'ProductDetail',query:{VendorProductID:item.RelationID}}">
                          <i class="fa-solid fa-eye"></i> مشاهده کامل
                        </router-link>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-9 bg-white rounded-lg pl-1">
                      <v-avatar size="38">
                        <img v-if="item.AppUserUrl !== null" :src="$replaceHttps(item.AppUserUrl)"
                             alt="تصویر کاربر">
                        <i v-else class="fas fa-circle-user fa-3x"></i>
                      </v-avatar>
                      <span class="font-weight-bold mr-1 d-inline-block" dir="ltr">: {{ item.AppUserName }} </span>
                      <span class="font-weight-normal">{{ item.Description }}</span>
                    </div>
                    <div class="col-3 text-left">
                      <div>{{ $convertDate(item.ModifiedDate) }}</div>
                      <div>{{ item.Rate }} <i class="fa-solid fa-star yellow--text"></i></div>
                    </div>
                    <div class="col-12">
                      <div class="row">
                        <div class="col-1"><i class="fa-solid fa-arrow-turn-down-left fa-lg"></i></div>
                        <div class="col-8 bg-white rounded-lg pb-0">
                          <span class="font-weight-bold mr-1">پاسخ شما :</span>
                          <span class="font-weight-normal">{{ item.AnswerDescription }}</span>
                        </div>
                        <div class="col-3 text-left py-0 reply-comments-action px-0">
                          <div>
                            <span class="d-inline-block w-50">{{ item.CountLike }}</span>
                            <v-btn class="d-inline-block w-50" icon small><i
                                class="fa-solid fa-thumbs-up fa-xl  green--text"></i></v-btn>
                          </div>
                          <div>
                            <span class="d-inline-block w-50">{{ item.CountDislike }}</span>
                            <v-btn class="d-inline-block w-50" icon small><i
                                class="fa-solid fa-thumbs-down fa-xl  red--text"></i></v-btn>
                          </div>
                          <div>
                            پاسخ
                            <v-btn icon @click="openAnswerComment(item.VoteID)"><i class="fa-solid fa-reply fa-xl"></i>
                            </v-btn>
                          </div>
                        </div>
                      </div>
                      <v-checkbox
                          v-model="item.ShowInProfile"
                          @change="changeShowInProfile(item.VoteID,item.ShowInProfile)">
                        <template slot="label">
                          <div class="font12px">
                            آیا مایلید در پروفایل کاربری خود این نظر انتشار یابد؟
                          </div>

                        </template>
                      </v-checkbox>
                    </div>
                  </div>
                </div>


              </div>
            </div>
          </div>

        </div>
        <div v-if="postsCommentsTab" class="row">
          <div v-if="postsComments.length <= 0" class="col-12  text-center">
            <div><i class="fa-light fa-face-frown-slight fa-3x grey--text"></i></div>
            <div class="mt-2">
              هنوز نظری ثبت نشده است
            </div>

          </div>
          <div v-else class="col-md-6 mx-auto pt-0">
            <div class="container">
              <div v-for="item in postsComments" :key="item.id" class="row ">
                <div class="col-12  mx-auto">
                  <div class="row">
                    <div class="col-4 p-1">
                      <v-img :height="$vuetify.breakpoint.xs ? 117 : 140" :src="$replaceHttps(item.ProductImageUrl)"
                             class="rounded-lg">
                      </v-img>
                    </div>
                    <div class="col-8 px-0 d-flex flex-column justify-content-end text-left pl-2">
                      <div>
                        <router-link    :to="{name:'TrendDetail',query:{VendorSocialNetworkID:item.RelationID}}" class="d-inline-block">
                          <i class="fa-solid fa-eye"></i> مشاهده کامل
                        </router-link>
                      </div>
                    </div>

                  </div>
                  <div class="row">
                    <div class="col-9 bg-white rounded-lg pl-1">
                      <v-avatar size="38">
                        <img v-if="item.AppUserUrl !== null" :src="$replaceHttps(item.AppUserUrl)" alt="تصویر کاربر">
                        <i v-else class="fas fa-circle-user fa-3x"></i>

                      </v-avatar>
                      <span class="font-weight-bold mr-1 d-inline-block" dir="ltr">: {{ item.AppUserName }} </span>
                      <span class="font-weight-normal" v-html="item.Description"></span>
                    </div>
                    <div class="col-3 text-left">
                      <div>{{ $convertDate(item.ModifiedDate) }}</div>
                      <div>{{ item.Rate }} <i class="fa-solid fa-star yellow--text"></i></div>
                    </div>
                    <div class="col-12">
                      <div class="row">
                        <div class="col-1"><i class="fa-solid fa-arrow-turn-down-left fa-lg"></i></div>
                        <div class="col-8 bg-white rounded-lg pb-0">
                          <span class="font-weight-bold mr-1">پاسخ شما :</span> {{ item.AnswerDescription }}
                        </div>
                        <div class="col-3 text-left py-0 reply-comments-action px-0">
                          <div>
                            <span class="d-inline-block w-50">{{ item.CountLike }}</span>
                            <v-btn class="d-inline-block w-50" icon small><i
                                class="fa-solid fa-thumbs-up fa-xl  green--text"></i></v-btn>
                          </div>
                          <div>
                            <span class="d-inline-block w-50">{{ item.CountDislike }}</span>
                            <v-btn class="d-inline-block w-50" icon small><i
                                class="fa-solid fa-thumbs-down fa-xl  red--text"></i></v-btn>
                          </div>
                          <div>
                            پاسخ
                            <v-btn icon  @click="openAnswerComment(item.VoteID)"><i class="fa-solid fa-reply fa-xl"></i>
                            </v-btn>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
            </div>
          </div>

        </div>
        <div v-if="storesCommentsTab" class="row">
          <div v-if="storesComments.length <= 0" class="col-12  text-center">
            <div><i class="fa-light fa-face-frown-slight fa-3x grey--text"></i></div>
            <div class="mt-2">
              هنوز نظری ثبت نشده است
            </div>

          </div>
          <div v-else class="col-md-6 mx-auto pt-0">
            <div class="container">
              <div v-for="(item,i) in storesComments" :key="i" class="row ">
                <div class="col-12  mx-auto">
                  <div class="row">
                    <div class="col-9 bg-white rounded-lg pl-1">
                      <v-avatar size="38">
                        <img v-if="item.AppUserUrl !== null" :src="$replaceHttps(item.AppUserUrl)"
                             alt="تصویر کاربر">
                        <i v-else class="fas fa-circle-user fa-3x"></i>
                      </v-avatar>
                      <span class="font-weight-bold mr-1 d-inline-block" dir="ltr">: {{ item.AppUserName }} </span>
                      <span class="font-weight-normal" v-html="item.Description"></span>
                    </div>
                    <div class="col-3 text-left">
                      <div> {{ $convertDate(item.ModifiedDate) }}</div>
                      <div>{{ item.Rate }} <i class="fa-solid fa-star yellow--text"></i></div>
                    </div>
                    <div class="col-12">
                      <div class="row">
                        <div class="col-1"><i class="fa-solid fa-arrow-turn-down-left fa-lg"></i></div>
                        <div class="col-8 bg-white rounded-lg pb-0">
                          <span class="font-weight-bold mr-1">پاسخ شما :</span> {{ item.AnswerDescription }}
                        </div>
                        <div class="col-3 text-center  py-0 pl-0 reply-comments-action pr-0">
                          <div>
                            <span class="d-inline-block w-50 ">{{ item.CountLike }}</span>
                            <v-btn class="d-inline-block w-50" icon small><i
                                class="fa-solid fa-thumbs-up fa-xl  green--text"></i></v-btn>
                          </div>
                          <div>
                            <span class="d-inline-block w-50 ">{{ item.CountDislike }}</span>
                            <v-btn class="d-inline-block w-50" icon small><i
                                class="fa-solid fa-thumbs-down fa-xl  red--text"></i></v-btn>
                          </div>
                          <div>
                            پاسخ
                            <v-btn icon @click="openAnswerComment(item.VoteID)"><i class="fa-solid fa-reply fa-xl"></i>
                            </v-btn>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
            </div>
          </div>

        </div>
      </div>
    </v-main>
    <v-bottom-sheet v-model="openSendCommentSheet">
      <v-sheet
          class="rounded-t-xl ">
        <div class="row align-items-center">

          <div class="col-auto font-weight-bold pr-8 primary-text">
            <i class="fa-solid fa-reply fa-xl"></i>
            پاسخ
          </div>

          <div class="col text-left  pl-6">
            <v-btn
                icon
                @click="openSendCommentSheet = !openSendCommentSheet">
              <i class="fa-regular fa-circle-xmark fa-xl"></i>

            </v-btn>
          </div>
        </div>
        <div class="row mx-1">
          <div class="col-12 ">
            <v-textarea
                v-model="answerDesc"
                auto-grow
                background-color="secondary"
                flat
                full-width
                hide-details
                placeholder="پاسخ خود را ینویسید ..."
                rows="4"
                solo>
            </v-textarea>
          </div>
          <div class="col-12 text-left pt-0 pl-0">
            <v-btn class="pl-1 pb-1" icon @click="registerAnswerComment">
              <i class="fa-solid fa-square-check fa-2x"></i>
            </v-btn>
          </div>
        </div>
      </v-sheet>
    </v-bottom-sheet>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
    <v-snackbar
        v-model="showResult"
        :multi-line="true"
        color="primary">
      {{ resultText }}

      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" icon @click="showResult = false ">
          <i class="fa-solid fa-circle-xmark fa-xl white--text"></i>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import BackBar from "@/components/BackBar";

export default {
  name: "SellerComments",
  metaInfo: {
    title: 'ایوان خانه- نظرات',
  },
  components: {BackBar},
  data: () => ({
    showLoaderDialog: false,
    showResult: false,
    resultText: '',
    productsCommentsTab: true,
    postsCommentsTab: false,
    storesCommentsTab: false,
    openSendCommentSheet: false,
    productsComments: [],
    postsComments: [],
    storesComments: [],
    voteID: null,
    answerDesc: null,
  }),
  mounted() {
    this.getProductsComments()
    this.getPostsComments()
    this.getStoreComments()
  },
  methods: {
    showProductsCommentsTab() {
      this.productsCommentsTab = true;
      this.postsCommentsTab = false;
      this.storesCommentsTab = false;
    },
    showPostsCommentsTab() {
      this.productsCommentsTab = false;
      this.postsCommentsTab = true;
      this.storesCommentsTab = false;
    },
    showStoresCommentsTab() {
      this.productsCommentsTab = false;
      this.postsCommentsTab = false;
      this.storesCommentsTab = true;
    },
    getProductsComments() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/VoteManagement/_ListProduct", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.productsComments = JSON.parse(result)
          })
          .catch(error => console.log('error', error));
    },
    getPostsComments() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/VoteManagement/_ListSocial", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.postsComments = JSON.parse(result)
          })
          .catch(error => console.log('error', error));
    },
    getStoreComments() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/VoteManagement/_ListVendor", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.storesComments = JSON.parse(result)
          })
          .catch(error => console.log('error', error));

    },
    openAnswerComment(id) {
      this.openSendCommentSheet = true
      this.voteID = id
    },
    registerAnswerComment() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VoteID", this.voteID);
      urlencoded.append("AnswerDescription", this.answerDesc);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/VoteManagement/_AnswerComment", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true
            this.answerDesc = null
            this.openSendCommentSheet = false
            this.getProductsComments()
            this.getPostsComments()
            this.getStoreComments()
          })
          .catch(error => console.log('error', error));
    },
    changeShowInProfile(id, status) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("VoteID", id);
      urlencoded.append("ShowInProfile", status);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/VoteManagement/SetShowInProfile", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true
          })
          .catch(error => console.log('error', error));
    },


  }
}
</script>
